import { FeatureAppConfig } from '../typing/main';
import { useFeatureAppEnvironment } from './use-feature-app-environment';

export function useFeatureAppConfig(): FeatureAppConfig {
  let { config = {}, baseUrl = '' } = useFeatureAppEnvironment();

  if (!config?.faHostServerUrl) {
    config = { ...config, faHostServerUrl: baseUrl };
  }

  return config;
}
